<div class="tcf re-dialog">
  <header class="tcf-header">
    <h2>{{ mode === 'create' ? 'New role' : (roleDetail?.name || 'Edit role') }}</h2>
  </header>

  <div class="tcf-body">
    <div *ngIf="loading" class="re-loading">Loading…</div>

    <div *ngIf="!loading" class="re-grid" [formGroup]="form">
      <!-- Left: name + description -->
      <div class="re-left">
        <label class="field">
          <span class="field-label">Name <em>*</em></span>
          <input type="text" formControlName="name" />
          <span class="field-error" *ngIf="form.get('name')?.touched && form.get('name')?.hasError('required')">Required</span>
          <span class="field-error" *ngIf="form.get('name')?.hasError('maxlength')">Max 64 characters</span>
          <span class="field-error" *ngIf="form.get('name')?.hasError('nameConflict')">A role with this name already exists</span>
        </label>

        <label class="field">
          <span class="field-label">Description</span>
          <textarea formControlName="description" rows="3"></textarea>
        </label>

        <div class="re-readonly" *ngIf="!auth.hasPermission('Role.Manage')">
          You have view-only access to roles
        </div>
      </div>

      <!-- Right: permission matrix -->
      <div class="re-right">
        <span class="re-perm-title">Permissions</span>
        <div class="re-group" *ngFor="let group of permissionGroups">
          <label class="re-group-head">
            <input type="checkbox"
                   [checked]="categoryAllChecked(group)"
                   [indeterminate]="categoryIndeterminate(group)"
                   (change)="toggleCategory(group, $any($event.target).checked)"
                   [disabled]="!auth.hasPermission('Role.Manage')" />
            <span class="re-group-name">
              {{ group.category }}
              <span class="re-group-count">({{ categoryCheckedCount(group) }}/{{ group.permissions.length }})</span>
            </span>
          </label>

          <label class="re-perm-row" *ngFor="let p of group.permissions">
            <input type="checkbox"
                   [checked]="isChecked(p.key)"
                   (change)="toggleKey(p.key)"
                   [disabled]="!auth.hasPermission('Role.Manage')" />
            <span class="re-perm-text">
              <span class="re-perm-key">{{ p.key }}</span>
              <span class="re-perm-desc">{{ p.description }}</span>
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <footer class="tcf-actions">
    <button type="button" class="br-btn br-btn--ghost" (click)="cancel()">Cancel</button>
    <button type="button" class="br-btn br-btn--primary" *ngIf="auth.hasPermission('Role.Manage')"
            [disabled]="form.invalid || submitting" (click)="save()">
      {{ submitting ? 'Saving…' : 'Save' }}
    </button>
  </footer>
</div>
